(function () {
  if (!document.body || !document.body.classList.contains('template-suffix-no-grouping')) return;

  function expandPagination(swiper) {
    if (!swiper || !swiper.params || !swiper.params.pagination) return;
    if (swiper.params.pagination.dynamicBullets) {
      swiper.params.pagination.dynamicBullets = false;
      if (swiper.pagination && typeof swiper.pagination.render === 'function') {
        swiper.pagination.render();
        swiper.pagination.update();
      } else if (typeof swiper.update === 'function') {
        swiper.update();
      }
    }
  }

  function run() {
    document.querySelectorAll('.template-suffix-no-grouping .theme-gallery .swiper-container').forEach(function (el) {
      if (el.swiper) expandPagination(el.swiper);
    });
  }

  // Swiper inits on DOMContentLoaded/theme ready; retry briefly
  run();
  document.addEventListener('DOMContentLoaded', run);
  var n = 0;
  var t = setInterval(function () {
    run();
    if (++n > 20) clearInterval(t);
  }, 250);
})();
